module.exports = __webpack_public_path__ + "img/share_active_orange.8c719aec.svg";